export const B2C_POLICIES = {
  names: {
    resetPassword: "b2c_1a_passwordreset_test",
  },
};

export const REDIRECT_ERROR_CODES = {
  forgotPassword: "AADB2C90118",
};

export const SAFETY_BUFFER_SECONDS = 120; // 2 minutes

export const SIGN_IN_REASONS = {
  signInInProgress: "signInInProgress",
  signedOut: "signedOut",
} as const;

export const SIGN_IN_ELSEWHERE_POLL_MS = 3000;
export const LOGOUT_SIGNAL_KEY = "auth.logoutSignal";
export const PENDING_LOGOUT_KEY = "auth.pendingLogout";
export const LOGIN_ATTEMPT_KEY = "auth.loginAttempt";
export const PRESERVED_KEY_PREFIXES = ["msal", "auth."];
